export const PRICE_TYPE_NET = 'net';
export const PRICE_TYPE_GROSS = 'gross';

export const getPriceValueDependentOnShowPrice = (priceInput, showPriceInput, vatValue, showPriceOutput) => {
    if (showPriceInput === showPriceOutput) {
        return priceInput;
    }

    if (showPriceInput === PRICE_TYPE_NET) {
        return Math.round(priceInput * (1 + vatValue / 100) * 100) / 100;
    }
    if (showPriceInput === PRICE_TYPE_GROSS) {
        return Math.round(priceInput / (1 + vatValue / 100) * 100) / 100;
    }

    return '0.00';
}